<template>
  <div
    class="order-item-card c:row-center-start"
    :class="{ 'is-last': isLast }"
  >
    <div class="order-item-pic">
      <div class="order-item-pic-img-container c:row-center" alt="">
        <img
          v-if="!imgList"
          class="order-item-pic-img"
          :class="{ default: isDefaultUrl }"
          :src="imgUrl"
          alt=""
          @click="openImageViewer(0)"
        />
        <van-swipe
          v-else
          ref="orderItemSwipe"
          class="order-item-pic-img"
          :show-indicators="false"
          :initial-swipe="currentImageIndex"
          @change="onSwipeChange"
          @touchstart.stop
          @touchmove.stop
          @touchend.stop
        >
          <van-swipe-item
            v-for="(item, index) in imgList"
            :key="`${item}-${index}`"
          >
            <img
              class="swiper-img"
              :src="item"
              @click="openImageViewer(index)"
            />
          </van-swipe-item>
          <template #indicator>
            <div
              class="custom-indicator"
              :class="{
                add: brandInfo.extra.manualUploadImgEnabled && isCreate
              }"
            >
              <div
                class="indicator-dot"
                v-for="(item, index) in imgList.length"
                :key="item"
                :class="{ active: index === currentShowIndex }"
              ></div>
            </div>
          </template>
        </van-swipe>
        <div
          class="markdown-icon"
          v-show="data.markDown === 'MRKD_PRICE_G' && this.showMarkDown"
        >
          Mark Down
        </div>
        <div
          class="upload-label"
          @click="openUploadImage"
          v-if="brandInfo.extra.manualUploadImgEnabled && isCreate"
        >
          <img src="@/assets/icons/icon-add.svg" />
          图片
        </div>
      </div>
    </div>
    <div class="order-item-infos">
      <div class="order-item-infos-header c:row-between-start">
        <span
          class="order-item-title"
          v-if="adjustPrice"
          @click="goToAdjustPriceDetail"
        >
          {{ data.productName || data.name }}</span
        >
        <span class="order-item-title" v-else>
          {{ data.productName || data.name }}</span
        >
        <span
          v-if="isCreate"
          class="order-item-delete"
          @click="throttledOnDeleteClick"
        >
          <img src="@/assets/icons/trash.svg" alt="" />
        </span>
        <span
          v-else-if="adjustPrice && status !== undefined && status !== null"
          class="order-item-count"
          :class="{ black: [0, 1].includes(status), red: status === 2 }"
          >{{ status | statusFilter }}</span
        >
        <span v-else-if="!isSimple" class="order-item-count"
          >x{{ data.qty }}</span
        >
      </div>
      <div class="order-item-infos-cells c:col-start">
        <div class="order-item-info-cell">
          <span class="order-item-info-label">产品编码：</span>
          <span class="order-item-info-value">{{
            data.sku || data.productSku
          }}</span>
        </div>
        <div class="order-item-info-cell">
          <span class="order-item-info-label">颜色：</span>
          <span class="order-item-info-value">{{
            data.color || data.productColor
          }}</span>
          <span class="order-item-info-label inline-label">尺码：</span>
          <span class="order-item-info-value">{{
            data.size || data.productSize
          }}</span>
        </div>
        <div v-if="runInWxWork && !isSimple" class="order-item-info-cell">
          <span class="order-item-info-label">备注 (内部可见)：</span>
          <span class="order-item-info-value">{{
            data.innerRemark || ''
          }}</span>
        </div>
        <div v-if="!isSimple" class="order-item-info-cell">
          <span class="order-item-info-cell">{{
            runInWxWork ? '备注 (客人可见)：' : '备注：'
          }}</span>
          <span class="order-item-info-value">{{ data.remark || '' }}</span>
        </div>
        <div
          v-if="adjustPrice"
          class="order-item-info-cell"
          @click="goToOrderDetail"
        >
          <span class="order-item-info-cell">订单号：</span>
          <span class="order-item-info-value">{{ data.orderNo || '' }}</span>
        </div>
      </div>
      <div class="order-item-price c:row-between-center">
        <div class="order-item-price-value c:row-between-center">
          <span>
            ¥ {{ (data.adjustedPrice || data.price) | filterPrice }}
          </span>
        </div>
        <span class="order-item-price-value-qty" v-if="adjustPrice">x1</span>
        <div
          v-if="isCreate && canModifyPrice"
          class="order-item-price-changer"
          @click="throttledOnModifyPriceClick"
        >
          修改价格
        </div>
        <div
          v-if="isCreate && canChangeCount"
          class="order-item-count-changer"
        >
          <CStepper v-model="num" :min="1" @change="changeQuantity" />
        </div>
      </div>
      <div
        v-if="data.adjustedPrice && !isSimple"
        class="order-item-adjust-price c:row-start-end"
      >
        <div class="order-item-infos-cells c:col-start">
          <div
            class="order-item-info-cell bold-cell"
            v-show="currentShowMarkDown"
          >
            <span class="order-item-info-label">原价：</span>
            <span class="order-item-info-value line-through-value"
              >¥{{ markdownPrice | filterPrice }}</span
            >
          </div>
          <div
            class="order-item-info-cell"
            v-show="runInWxWork && data.adjustPriceInnerRemark"
          >
            <span class="order-item-info-label">调价原因：</span>
            <span class="order-item-info-value">{{
              data.adjustPriceInnerRemark
            }}</span>
          </div>
        </div>
        <div class="readjust-price" v-if="isRejected">
          <div class="reapply-button" @click="throttledOnReAdjustPriceClick">
            重新申请
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CStepper from '@/components/common/CStepper.vue'
  import { throttle } from '@/utils'
  import { mapState, mapGetters } from 'vuex'

  export default {
    components: { CStepper },
    props: {
      isLast: {
        type: Boolean,
        default: false
      },
      isCreate: {
        type: Boolean,
        default: false
      },
      isSimple: {
        type: Boolean,
        default: false
      },
      status: {
        type: Number,
        default: 0
      },
      isRejected: {
        type: Boolean,
        default: false
      },
      canModifyPrice: {
        type: Boolean,
        default: false
      },
      canChangeCount: {
        type: Boolean,
        default: true
      },
      index: {
        type: Number
      },
      data: {
        type: Object
      },
      currentImageIndex: {
        type: Number,
        default: 0
      },
      // 是否是调价卡片
      adjustPrice: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        currentShowIndex: 0,
        imgUrl: '',
        isDefaultUrl: false,
        num: 0,
        showMarkDown: false,
        currentShowMarkDown: false,
        markdownPrice: ''
      }
    },
    computed: {
      ...mapState(['brandInfo']),
      ...mapGetters(['runInWxWork']),
      imgList() {
        if (
          this.data.manualUploadImageShows &&
          this.data.manualUploadImageShows.length > 0
        ) {
          return [this.imgUrl, ...this.data.manualUploadImageShows]
        }
        return null
      },
      displayImages() {
        return this.imgList || [this.imgUrl]
      }
    },
    filters: {
      statusFilter(status) {
        switch (status) {
          case 0:
            return '待审核'
          case 1:
            return '已审批'
          case 2:
            return '已驳回'
          default:
            return ''
        }
      }
    },
    watch: {
      data: {
        handler: function (itemData) {
          this.checkShowMarkDown(itemData)
          if (
            !(itemData.productPicSmall || itemData.productPic || itemData.pic)
          ) {
            this.imgUrl = this.$store.state.brandInfo.shareImage
            this.isDefaultUrl = true
          } else {
            this.imgUrl =
              itemData.productPicSmall || itemData.productPic || itemData.pic
            this.isDefaultUrl = false
          }
        },
        immediate: true,
        deep: true
      },
      'data.qty': function (value) {
        if (value !== this.num) {
          this.num = value
        }
      },
      currentImageIndex: {
        handler: function (newIndex) {
          console.log('currentImageIndex changed:', newIndex)
          this.currentShowIndex = newIndex
        },
        immediate: true
      }
    },
    created() {
      this.throttledOnDeleteClick = throttle(this.delete, 500)
      this.throttledOnModifyPriceClick = throttle(this.modifyPrice, 500)
      this.throttledOnReAdjustPriceClick = throttle(this.reAdjustPrice, 500)
    },
    methods: {
      goToOrderDetail() {
        this.$router.push({
          name: 'Order',
          query: {
            orderNo: this.data.orderNo
          }
        })
      },
      goToAdjustPriceDetail() {
        this.$router.push({
          name: 'AdjustPrice',
          query: {
            id: this.data.orderItemId,
            orderNo: this.data.orderNo
          }
        })
      },
      delete() {
        // console.log("del");
        this.$emit('delete', {
          qty: this.num,
          index: this.index
        })
      },
      checkShowMarkDown(data) {
        this.showMarkDown =
          this.$store.state.brandInfo.markdown?.enabled === true
        if (
          (this.showMarkDown &&
            !data.adjustedPrice &&
            data.adjustedPrice !== data.originalPrice) ||
          (data.adjustedPrice && data.adjustedPrice < data.originalPrice)
        ) {
          this.currentShowMarkDown = true
          this.markdownPrice = data.originalPrice
        } else {
          this.currentShowMarkDown = false
        }
      },
      changeQuantity(num) {
        console.log('changeQuantity', this.num, num)
        this.$emit('changequantity', {
          qty: this.num,
          index: this.index,
          sku: this.data.productSku
        })
      },
      modifyPrice() {
        // console.log("modifyPrice", this.index);
        this.$emit('modifyprice', {
          data: this.data,
          index: this.index
        })
      },
      reAdjustPrice() {
        this.$emit('readjustprice', {
          data: this.data,
          index: this.index
        })
      },
      openUploadImage() {
        this.$emit('openUploadImage')
      },
      onSwipeChange(index) {
        this.currentShowIndex = index
      },

      openImageViewer(index) {
        this.$emit('openImageViewer', {
          orderIndex: this.index,
          imageIndex: index,
          images: this.displayImages
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .order-item-card {
    gap: 8/20rem;

    width: 100%;
    height: auto;
    padding: 16/20rem 0;
    border-bottom: 1/20rem solid #e4e4e4;

    &.is-last {
      border-bottom: none;
    }

    .order-item-pic {
      aspect-ratio: 100/130;
      background-color: #fff;
      width: 100/20rem;
      // height: 130/20rem;

      &-img-container {
        aspect-ratio: 100/130;
        width: 100/20rem;
        // height: 130/20rem;

        .order-item-pic-img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          &.van-swipe {
            width: 100/20rem;
            height: 130/20rem;
            .van-swipe-item {
              width: 100/20rem !important;
              height: 130/20rem !important;
              .swiper-img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                display: block;
              }
            }
            .custom-indicator {
              position: absolute;
              bottom: 8/20rem;
              left: 0;
              width: 100%;
              height: 1px;
              display: flex;
              align-items: center;
              justify-content: center;
              &.add {
                bottom: 35/20rem;
              }
              .indicator-dot {
                width: 10/20rem;
                height: 1px;
                background-color: #00000029;
                &.active {
                  background-color: #000000;
                }
              }
            }
          }
          &.default {
            max-width: 50%;
            max-height: 50%;
          }
        }
      }
    }

    .order-item-infos {
      flex: 1;
      width: 0;
      height: auto;

      &-header {
        gap: 10/20rem;
        margin-bottom: 10/20rem;

        .order-item-title {
          line-height: 21/20rem;
          font-size: 15/20rem;
          font-weight: 500;
          letter-spacing: 0;
          color: #1b1b1b;
        }

        .order-item-count {
          line-height: 17/20rem;
          font-size: 12/20rem;
          font-weight: 400;
          letter-spacing: 2/20rem;
          color: #5e5e5e;
          &.black {
            font-size: 14/20rem;
            font-weight: 500;
            color: #1b1b1b;
            letter-spacing: 0;
          }
          &.red {
            font-size: 14/20rem;
            font-weight: 500;
            color: #ed7867;
            letter-spacing: 0;
          }
        }
        .order-item-delete {
          width: 20/20rem;
          height: 20/20rem;
          img {
            width: 20/20rem;
            height: 20/20rem;
          }
        }
      }

      &-cells {
        gap: 3/20rem;

        .order-item-info-cell {
          min-height: 15/20rem;
          line-height: 15/20rem;
          font-weight: 400;
          font-size: 11/20rem;
          letter-spacing: 0;
          color: #7d7d7d;

          &.bold-cell {
            font-weight: 500;
          }
          .inline-label {
            margin-left: 16/20rem;
          }
          .line-through-value {
            text-decoration: line-through;
          }
        }
      }
    }

    .order-item-price {
      gap: 15/20rem;

      width: 100%;
      height: 21/20rem;
      margin-top: 8/20rem;

      &-value {
        width: fit-content;
        line-height: 21/20rem;
        font-size: 15/20rem;
        font-weight: 500;
        letter-spacing: 0;
        color: #000;
        &-qty {
          font-size: 12/20rem;
          color: #5e5e5e;
          font-weight: 400;
        }
      }

      &-changer {
        flex: 1;
        width: 0;
        line-height: 20/20rem;
        font-size: 12/20rem;
        font-weight: 400;
        letter-spacing: 0;
        color: #515151;
        text-decoration: underline;
      }
    }

    .order-item-adjust-price {
      width: 100%;
      .readjust-price {
        flex: 1;
        width: 0;
        text-align: right;

        .reapply-button {
          box-sizing: border-box;
          display: inline-block;
          width: auto;
          height: 24/20rem;
          padding: 0 16/20rem;
          border: 1/20rem solid #000000;

          line-height: 24/20rem;
          font-weight: 400;
          font-size: 12/20rem;
          letter-spacing: 0;
          text-align: center;
          vertical-align: middle;
        }
      }
    }
  }
  .order-item-pic-img-container {
    position: relative;
    .markdown-icon {
      position: absolute;
      left: 2px;
      top: 2px;
      padding: 4px;
      font-size: 10px;
      background-color: #c1c2c6;
      color: #fff;
      border-radius: 4px;
    }
    .upload-label {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100/20rem;
      height: 26/20rem;
      background-color: #0000004d;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      img {
        width: 8px;
        height: 8px;
      }
      font-family: PingFang SC;
      font-style: Regular;
      font-size: 10px;
      color: #fff;
    }
  }
</style>
